import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { toast } from "react-toastify";
import Request from "../../../../helpers/request";
import * as url from "../../../../helpers/url_helper";
import ConfirmationModal from "../../../../components/Common/ConfirmationModal";

export interface WifiModalProps {
  headerTitle?: string;
  selectedRows: any[];
  deviceType: string;
  cancleBtnClick(): void;
  handleRefresh(): void;
}

const WifiModal = ({
  headerTitle = "Update WiFi",
  selectedRows,
  deviceType,
  cancleBtnClick,
  handleRefresh,
}: WifiModalProps) => {
  const [wifiSsid, setWifiSsid] = useState("");
  const [wifiPassword, setWifiPassword] = useState("");
  const [wifiLoading, setWifiLoading] = useState(false);
  const [isWifiConfirmModalOpen, setIsWifiConfirmModalOpen] = useState(false);

  useEffect(() => {
    setWifiSsid("");
    setWifiPassword("");
    setIsWifiConfirmModalOpen(false);
    setWifiLoading(false);
  }, []);

  const toggleWifiModal = () => {
    if (!wifiLoading) {
      cancleBtnClick();
    }
  };

  const handleWifiSubmit = () => {
    if (!wifiSsid.trim() || !wifiPassword.trim()) {
      toast.error("SSID and password are required.");
      return;
    }
    setIsWifiConfirmModalOpen(true);
  };

  const updateWifiApiCall = () => {
    setWifiLoading(true);
    const reqObj = {
      deviceType,
      deviceIds: selectedRows.map((item) => item.id || item._id),
      ssid: wifiSsid.trim(),
      password: wifiPassword.trim(),
    };

    Request.post(`${url.BASE_URL}${url.UPDATE_DEVICE_WIFI}`, reqObj)
      .then((res) => {
        toast.success(res.data.msg || "WiFi update initiated successfully.");
        setIsWifiConfirmModalOpen(false);
        cancleBtnClick();
        handleRefresh();
        setWifiLoading(false);
      })
      .catch((err) => {
        setWifiLoading(false);
        toast.error(
          err.response?.data?.msg ||
            err.response?.data?.errors?.[0]?.msg ||
            "Failed to update WiFi.",
        );
      });
  };

  return (
    <>
      <Modal
        isOpen={true}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        toggle={toggleWifiModal}
      >
        <div className="modal-content">
          <ModalHeader style={{ justifyContent: "center" }}>
            {headerTitle}
          </ModalHeader>
          <ModalBody>
            <div className="mb-3">
              <label className="form-label fw-semibold">Selected Slaves</label>
              <div
                className="d-flex flex-wrap gap-1 p-2 bg-light rounded"
                style={{ maxHeight: "120px", overflowY: "auto" }}
              >
                {selectedRows.map((row) => (
                  <span
                    key={row.id || row._id || row.slave}
                    className="badge bg-secondary"
                  >
                    {row.slave || "-"}
                  </span>
                ))}
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold">SSID</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter WiFi SSID"
                value={wifiSsid}
                onChange={(e) => setWifiSsid(e.target.value)}
                disabled={wifiLoading}
              />
            </div>
            <div>
              <label className="form-label fw-semibold">Password</label>
              <input
                type="password"
                className="form-control"
                placeholder="Enter WiFi password"
                value={wifiPassword}
                onChange={(e) => setWifiPassword(e.target.value)}
                disabled={wifiLoading}
              />
            </div>
          </ModalBody>
          <ModalFooter style={{ justifyContent: "center" }}>
            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={toggleWifiModal}
              disabled={wifiLoading}
            >
              Cancel
            </button>
            <button
              className="btn btn-dark"
              type="submit"
              onClick={handleWifiSubmit}
              disabled={wifiLoading}
            >
              Update WiFi
            </button>
          </ModalFooter>
        </div>
      </Modal>

      {isWifiConfirmModalOpen && (
        <ConfirmationModal
          headerTitle="Update WiFi?"
          text={`Are you sure you want to update WiFi for  selected devices
           with SSID?`}
          buttonText="Confirm"
          onClick={updateWifiApiCall}
          cancleBtnClick={() => setIsWifiConfirmModalOpen(false)}
          loading={wifiLoading}
        />
      )}
    </>
  );
};

export default WifiModal;
